<template>
  <div>
    <div v-if="error" class="danger darken-4 p3 mt3 mx3 white">
      {{ getReferencelabel(error.code) }}
    </div>
    <div class="white-bg px3 pt3 m3">
      <ContactForm
        v-model="contact"
        :error="error"
        @save-form="saveData()"
        @reset-form="resetForm()"
        @open-delete-contact-modal="openDeleteContactModal()"
      />
    </div>
    <Modal v-if="showModal" @close="closeDeleteContactModal">
        <template #body>
          <div class="col-12 flex flex-column items-center justify-center white-bg modal-qrcode-dimensions">
            <span class="h4n bold mb3">{{ getReferencelabel('DELETE_OTHER_TRAVELLERS') }}</span>
            <div class="flex col-12 gap1">
              <ButtonV2 :reference="'NO'" rounded class="px2 py1 col-6" color="light" :action="closeDeleteContactModal" />
              <ButtonV2 :reference="'YES'" rounded class="px2 py1 col-6" color="dark" :action="deleteContact" />
            </div>
          </div>
        </template>
      </Modal>
    </div>
</template>

<script>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { getUser, createContact, updateContact, deleteContact as deleteContactRequest } from '@/mixins/requests';
import { isInImpersonateModeNotification, errorNotification } from '@/mixins/utils';
import ContactForm from '@/components/forms/ContactForm.vue';
import { getReferencelabel } from '@/mixins/utils';
import ButtonV2 from '@/components/elements/ButtonV2';
import Modal from '@/components/blocks/Modal';

export default {
  components: { ContactForm, ButtonV2, Modal },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const user = { ...store.state.user };

    const contact = ref({ ...(store.state.contacts.find(u => u.uuid === route.params.uuid) || {}) });
    const error = ref(null);

    async function saveData() {
      if (isInImpersonateModeNotification()) {
        return;
      }

      store.commit('setLoading', true);
      const response = contact.value.uuid ? await updateContact(contact.value) : await createContact(contact.value);
      if (response?.success) {
        await getUser();
        router.replace({ name: 'MyContacts' });
      } else if (response?.message) {
        error.value = response;
        errorNotification('UPDATE_USER_ERROR_NOTIFICATION');
      }

      store.commit('setLoading', false);
    }

    const resetForm = () => {
      Object.assign(contact.value, { ...(store.state.contacts.find(u => u.uuid === route.params.uuid) || {}) });
    };

    const showModal = ref(false);

    const openDeleteContactModal = () => {
      showModal.value = true;
    };

    const closeDeleteContactModal = () => {
      showModal.value = false;
    };

    async function deleteContact() {
      if (isInImpersonateModeNotification()) {
        return;
      }

      store.commit('setLoading', true);
      user.contacts = user.contacts.filter(c => c.uuid !== contact.value.uuid);
      const response = await deleteContactRequest(contact.value.uuid);
      if (response.success) {
        await getUser();

        router.replace({ name: 'MyContacts' });
      }

      store.commit('setLoading', false);
    }

    return { contact, error, saveData, deleteContact, resetForm, getReferencelabel, closeDeleteContactModal, openDeleteContactModal, showModal, user };
  },
};
</script>

<style>
.input-height {
  height: 50px;
}
</style>
